import { makeAutoObservable, runInAction } from "mobx";
import { agent } from "../api/agent";
import { store } from "./store";
import { FriendDto } from "../models/FriendDto";

export default class FriendListStore {
    friends: FriendDto[] = [];
    loadingFriends = false;
    activeTab = 0;

    constructor() {
        makeAutoObservable(this);
    }

    setActiveTab = (activeTab: number) => {
        this.activeTab = activeTab;
    }

    loadFriends = async (userId: string, predicate: string) => {
        this.loadingFriends = true;
        try {
            const friends = await agent.Friends.list(userId, predicate);
            runInAction(() => {
                this.friends = friends;
                this.loadingFriends = false;
            });
        } catch (error) {
            console.log(error);
            runInAction(() => {
                this.loadingFriends = false;
            });
        }
    }

    updateFriendInList = (userId: string) => {
        runInAction(() => {
            this.friends = this.friends.filter(f => f.userId !== userId);
        });
    }
}